import { render, staticRenderFns } from "./PremiumUpdateModal.vue?vue&type=template&id=c7b64b54&lang=pug&"
import script from "./PremiumUpdateModal.vue?vue&type=script&lang=js&"
export * from "./PremiumUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports